/* WOD.LOL i18n — completes Shopify's translations (/en, /es, /de) by translating the theme's own strings in place
   from a dictionary (see snippets/wl-i18n-head.liquid).
   Text nodes are matched on their whitespace-normalised content; "p" patterns handle dynamic strings
   ({0}, {1}… = captured parts, themselves translated when they are dictionary entries). */
(function () {
  const I = window.WL_I18N;
  if (!I) return;

  /* ---------- Language switcher (snippets/wl-lang-switch.liquid + mobile drawer pills) ---------- */
  function syncSwitchers(lang) {
    document.querySelectorAll('[data-wl-lang-code]').forEach((el) => (el.textContent = lang.toUpperCase()));
    document.querySelectorAll('[data-wl-lang]:not(html)').forEach((b) => {
      const on = b.getAttribute('data-wl-lang') === lang;
      b.classList.toggle('is-active', on);
      if (on) b.setAttribute('aria-current', 'true');
      else b.removeAttribute('aria-current');
    });
  }
  document.addEventListener('click', (e) => {
    const b = e.target.closest && e.target.closest('[data-wl-lang]:not(html)');
    if (!b) return;
    e.preventDefault();
    const l = b.getAttribute('data-wl-lang');
    if (l === document.documentElement.getAttribute('data-wl-lang')) return I.setLang(l);
    I.go(l); /* Shopify locale URL (/en, /es, /de) when published, otherwise cookie + reload */
  });

  /* On /en|/es|/de pages, keep hard-coded internal links (custom sections) in the same language */
  if (I.cur && I.cur !== 'fr') {
    const pre = '/' + I.cur;
    const skip = /^\/(?:en|es|de|fr)(?:\/|$)|^\/(?:cdn|apps|services|tools|checkouts?|\.well-known|a\/)/;
    const fix = (a) => {
      const h = a.getAttribute('href');
      if (!h || h[0] !== '/' || h[1] === '/' || skip.test(h)) return;
      a.setAttribute('href', pre + (h === '/' ? '' : h));
    };
    ['click', 'auxclick', 'contextmenu'].forEach((t) =>
      document.addEventListener(t, (e) => { const a = e.target.closest && e.target.closest('a[href]'); if (a) fix(a); }, true)
    );
  }

  I.ready.then(({ lang, dict }) => {
    const run = () => {
      syncSwitchers(lang);
      if (!dict) return I.unhide();
      start(lang, dict);
    };
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run);
    else run();
  });

  function start(lang, dict) {
    const S = dict.s || {};
    /* pattern placeholders: {0} = any text (translated recursively), {#0} = a number */
    const P = (dict.p || []).map(([src, out]) => {
      const esc = src.replace(/[.*+?^$()|[\]\\]/g, '\\$&');
      const re = new RegExp(
        '^' + esc.replace(/\{#(\d)\}/g, '([\\d.,]+)').replace(/\{(\d)\}/g, '(.+?)') + '$',
        'i'
      );
      return [re, out, (src.match(/\{#?(\d)\}/g) || []).map((m) => +m.replace(/\D/g, ''))];
    });
    const norm = (s) => s.replace(/\s+/g, ' ').trim();

    function core(key, depth) {
      let out = S[key];
      if (out != null || depth > 4) return out;
      if (key.length > 140 || /[.!?…]\s/.test(key)) return null; /* patterns: labels/titles only, never prose */
      for (const [re, o, order] of P) {
        const m = key.match(re);
        if (m) {
          return o.replace(/\{(\d)\}/g, (_, i) => {
            const v = (m[order.indexOf(+i) + 1] || '').trim();
            const t = core(v, depth + 1);
            return t != null ? t : v;
          });
        }
      }
      return null;
    }
    function tr(raw) {
      const key = norm(raw);
      if (!key) return null;
      let out = core(key, 0);
      if (out == null && /[.!?…]\s/.test(key)) {
        /* paragraph assembled from several known sentences (e.g. size-guide advice) */
        let hit = false;
        out = key
          .split(/(?<=[.!?…][)»"”]?)\s+/)
          .map((p) => {
            const t = core(p, 0);
            if (t != null) hit = true;
            return t != null ? t : p;
          })
          .join(' ');
        if (!hit) out = null;
      }
      if (out == null || out === key) return null;
      const lead = raw.match(/^\s*/)[0];
      const trail = raw.match(/\s*$/)[0];
      return lead + out + trail;
    }

    const SKIP = /^(SCRIPT|STYLE|NOSCRIPT|TEXTAREA|CODE|PRE|TEMPLATE)$/;
    const mine = new WeakMap(); // node -> value we wrote
    const missing = (I.missing = new Set()); // debug: untranslated texts seen on this page
    function skipped(el) {
      for (; el && el !== document.body; el = el.parentElement) {
        if (SKIP.test(el.tagName) || el.getAttribute('translate') === 'no' || el.classList.contains('notranslate') || el.isContentEditable) return true;
      }
      return false;
    }
    function doText(n) {
      const v = n.nodeValue;
      if (!v || mine.get(n) === v || !/[A-Za-zÀ-ÿ]/.test(v)) return;
      const t = tr(v);
      if (t != null) {
        if (skipped(n.parentElement)) return; /* ancestor check only when there is something to write */
        mine.set(n, t);
        n.nodeValue = t;
      } else if (missing.size < 5000) {
        missing.add(norm(v));
      }
    }
    const ATTRS = ['placeholder', 'aria-label', 'title'];
    function doEl(el) {
      for (const a of ATTRS) {
        const v = el.getAttribute(a);
        if (v) {
          const t = tr(v);
          if (t != null) el.setAttribute(a, t);
        }
      }
      if (el.tagName === 'INPUT' && /^(submit|button)$/.test(el.type) && el.value) {
        const t = tr(el.value);
        if (t != null) el.value = t;
      }
    }
    function walk(root) {
      if (root.nodeType === 3) return doText(root);
      if (root.nodeType !== 1 || SKIP.test(root.tagName)) return;
      doEl(root);
      const tw = document.createTreeWalker(root, NodeFilter.SHOW_ELEMENT | NodeFilter.SHOW_TEXT, {
        acceptNode: (n) => (n.nodeType === 1 && SKIP.test(n.tagName) ? NodeFilter.FILTER_REJECT : NodeFilter.FILTER_ACCEPT),
      });
      let n;
      while ((n = tw.nextNode())) {
        if (n.nodeType === 3) doText(n);
        else doEl(n);
      }
      root.querySelectorAll && root.querySelectorAll('template').forEach((t) => walk(t.content));
    }

    const t = tr(document.title);
    if (t != null) document.title = t;
    else missing.add('TITLE:' + norm(document.title));
    walk(document.body);
    I.unhide();

    /* DOM changes (cart drawer, swatches, countdown…) are queued and translated once per frame,
       so a click never pays for several full walks of the same subtree. */
    const qText = new Set(), qEl = new Set(), qRoot = new Set();
    let queued = false;
    const flush = () => {
      queued = false;
      qRoot.forEach((r) => { if (r.isConnected) walk(r); });
      qEl.forEach((el) => { if (el.isConnected) doEl(el); });
      qText.forEach((n) => { if (n.isConnected) doText(n); });
      qRoot.clear(); qEl.clear(); qText.clear();
    };
    new MutationObserver((muts) => {
      for (const m of muts) {
        if (m.type === 'characterData') qText.add(m.target);
        else if (m.type === 'attributes') qEl.add(m.target);
        else m.addedNodes.forEach((n) => (n.nodeType === 3 ? qText.add(n) : n.nodeType === 1 && qRoot.add(n)));
      }
      if (!queued) { queued = true; requestAnimationFrame(flush); }
    }).observe(document.body, {
      childList: true,
      subtree: true,
      characterData: true,
      attributes: true,
      attributeFilter: ATTRS,
    });

    window.WL_I18N.t = (s) => tr(s) || s;
  }
})();
